export const DEFAULT_SUBJECT_SLUG = 'marketing'
export const BRAND_NAME = 'Jarvis'
